import Static from './Static';

const GameConfig = {};

(function (exports) {
    // The table of editing the chances of a symbol falling on each of the reels
    exports.symbolChance = [
        [11, 11, 11, 11, 11], // 0 - 10
        [11, 11, 11, 11, 11], // 1 - J
        [11, 11, 11, 11, 11], // 2 - Q
        [11, 11, 11, 11, 11], // 3 - K
        [11, 11, 11, 11, 11], // 4 - A
        [11, 11, 11, 11, 11], // 5 - Pharaoh
        [11, 11, 11, 11, 11], // 6 - Hunter
        [11, 11, 11, 11, 11], // 7 - scarab
        [11, 11, 11, 11, 11], // 8 - Tutankhamon
        [1, 1, 1, 1, 1], // 9 - Book
    ];

    // validation of input data
    for (let i = 0; i < exports.symbolChance[0].length; i++) {
        let sum = 0;
        exports.symbolChance.forEach((arr) => {
            sum += arr[i];
        });
        if (sum !== 100) { throw new Error(`Input error! Sum of chances of falling out on the wheel No${i + 1} should equal 100, now it is equal to ${sum}`); }
    }

    exports.symbolIncome = [];

    exports.wheelRotationTime = [250, 450, 650, 850, 1050]; // the time of rotation of the wheels to a full stop

    exports.wheelImmediateStopTime = [0, 0, 0, 0, 0]; // The time for which the wheels stop after pressing the STOP button

    exports.wheelTurboTime = [50, 50, 50, 50, 50]; // The time for which the wheels stop when the turbo button is pressed.

    exports.wheelRollingSpeed = 15;

    exports.isFinalBounce = true;
    exports.finalBounceForce = 30;
    exports.finalBounceDuration = 100;

    // starting positions of each wheel, at the top most left
    function rs() {
        return Static.randomInteger(0, 8);
    }

    exports.wheelStartingPositions = [
        [ // 0
            [0, 0, 0, 0], // the first character is initially hidden, others visible
            [0, 0, 0, 0],
            [0, 0, 0, 0],
            [0, 0, 0, 0],
            [0, 0, 0, 0],
        ],
        [ // 1
            [0, 0, 5, 6],
            [1, 1, 6, 7],
            [2, 2, 7, 1],
            [3, 3, 8, 2],
            [4, 4, 5, 3],
        ],
        [ // 2
            [rs(), rs(), rs(), rs()],
            [rs(), rs(), rs(), rs()],
            [rs(), rs(), rs(), rs()],
            [rs(), rs(), rs(), rs()],
            [rs(), rs(), rs(), rs()],
        ],
    ];

    exports.wheelStopPositions = [
        [rs(), rs(), rs()],
        [rs(), rs(), rs()],
        [rs(), rs(), rs()],
        [rs(), rs(), rs()],
        [rs(), rs(), rs()],
    ];

    // selectable paylines
    exports.paylines = {};

    exports.viewZone = '35';

    exports.paytable = {};

    exports.layoutFadeInOutTime = 150;

    // TODOSPEED
    exports.singleLineAnimationDuration = 900;
    // TODOSPEED
    exports.allLinesAnimationDuration = 900;
    // TODOSPEED
    exports.animationDelayBetweenLines = 300;

    // TODOSPEED
    exports.autospinPopupClosingTime = 6000;
    // TODOSPEED
    exports.autospinExpandingBookClosingTime = 1000;

    exports.expandingAcceleration = 0.2; // increase the speed of each subsequent expansion, the initial speed: 0.2

    exports.bigWinsObj = {
        bigWin: {
            maxBetMultiplier: 20,
            minBetMultiplier: 10,
        },
        monsterWin: {
            maxBetMultiplier: 50,
            minBetMultiplier: 20,
        },
        legendaryWin: {
            maxBetMultiplier: null,
            minBetMultiplier: 50,
        },
    };

    exports.mobileButtonState = {
        normal: 0,
        hover: 0,
        pressed: 1,
        disable: 2,
    };
}(GameConfig));

export default GameConfig;
